import React, { useEffect, useState , useContext} from "react";
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Link} from "react-router-dom";
import { Spinner } from "react-bootstrap";
import $ from 'jquery';
import { useParams, useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import UrlHouse from "../../utils/UrlHouse";
import DefaultProfile from '../../asset/default_profile.png';
import VerifiedBadge from '../../asset/verified_badge.png';
import { AppContext } from "../../utils/AppContext";
import Logo from '../../asset/logo_long_transparent_cropped.png';
import "../../spinner.css";

import {Helmet} from "react-helmet";
import axios from 'axios';
import { Label } from "recharts";

const ConfirmMessagePage = () => {

    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const params = useParams();
    const [isLoaded, setIsLoaded] = useState(false);

    const [messageData, setMessageData] = useState({
        messageName: "",
        messageType: 101,
        startDate: "",
        target: 0,
        messageBudget: 0
    })

    const desktopStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px"
        },

        selectImageButtonStyle: {
            display: "none"
        },

        imagePreviewStyle: {
            height: "30vh",
            margin: "10px"
        },

        sendButtonStyle: {
            
        }
    }

    const mobileStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px",
        },

        selectImageButtonStyle: {
            display: 'none'
        },

        imagePreviewStyle: {
            height: "30vh",
            margin: "10px"
        },

        sendButtonStyle: {
            
        }
    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles

    useEffect(() => {
      init();
    }, [])

    const init = () => {
        $.ajax({
            type: "POST",
            url: UrlHouse.CONFIRM_MESSAGE_INIT,
            data: JSON.stringify({
                email: localStorage.getItem("email"), password: localStorage.getItem("password"), message_id: params.id
            }),
            dataType: "json",
            success: function (response) {
                if(response.result === 1){
                    setIsLoaded(true);
                    setMessageData({
                        messageName: response.message_name,
                        messageType: response.message_type,
                        startDate: response.start_date,
                        target: response.target,
                        messageBudget: response.message_budget,
                    });
                }else if(response.result === 2){
                    navigate('/dashboard/message_ads/create/payment/'+params.id);
                }else{
                    navigate('/dashboard/message_ads/create/finish/'+params.id);
                }
            },
            error: function(e){
                navigate('/dashboard/message_ads');
            }
        });
    }

    const [linkPreview, setLinkPreview] = useState({
        title: "Woilo - Photo, Video, Chat, NFTs",
        description: "Woilo - Photo, Video, Chat, NFTs",
        url: "",
        imageUrl: ""
    })

	const onSubmitButtonClick = async() => {
        navigate('/dashboard/message_ads/create/invoice/'+params.id);
	};

    function getAdType(){
        if(messageData.messageType === 101){
            return "Pesan Teks";
        }
        if(messageData.messageType === 102){
            return "Pesan Foto";
        }
        if(messageData.messageType === 103){
            return "Pesan Video";
        }
        return "Pesan Teks";
    }

    function getAdBudget(){
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
        });
        return formatter.format(messageData.messageBudget);
    }

    return(
        <>
            <div style={styles.outerContainerStyle}>
                <Helmet>
                    <title>{linkPreview.title}</title>

                    <meta property="og:title" content={linkPreview.title} />
                    <meta property="og:description" content={linkPreview.description} />
                    <meta property="og:image" content={linkPreview.imageUrl} />
                    <meta property="og:url" content={linkPreview.url} />
                    <meta property="og:type" content="website"/>

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:domain" content="woilo.com" />
                    <meta property="twitter:url" content={linkPreview.url} />
                    <meta name="twitter:title" content={linkPreview.title} />
                    <meta name="twitter:description" content={linkPreview.description} />
                    <meta name="twitter:image" content={linkPreview.imageUrl} />
                </Helmet>
                {
                    isLoaded?<div style={styles.mainContainerStyle}>
                        <h1>Iklan Berhasil dibuat</h1>
                        <hr></hr>
                        <div>
                            <h5>Nama Iklan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{messageData.messageName}</h6>
                            <h5>Jenis Iklan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{getAdType()}</h6>
                            <h5>Tanggal Pengiriman Pesan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{messageData.startDate}</h6>
                            <h5>Target Pengguna</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{messageData.target} Pengguna</h6>
                            <h5>Biaya Pengeluaran Iklan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{getAdBudget()}</h6>
                        </div>


                        <div>
                            <Form>
                                <Form.Group as={Row} className="mb-3">
                                    <Col sm={{ span: 12}} style={{display: "flex"}}>
                                        <Button onClick={onSubmitButtonClick} style={styles.sendButtonStyle}>Konfirmasi Pesan</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>:<></>
                    
                }
            </div>
        </>
    )
}

export default ConfirmMessagePage;